<template>
  <div class="house">
    <div class="househeader">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png" style="margin-right:10px" alt="">
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
          <el-breadcrumb-item>工作桌面</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动列表</el-breadcrumb-item> -->
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <!-- <div class="refresh">
        <img width="16px" height="16px" src="@/assets/house/refresh.png" alt="">
        <p>刷新</p>
      </div> -->
    </div>


    <!-- 正文部分 -->
    <div class="housemain">

      <div style="width:100%;height:320px;">
        <div style="float:left;">
          <div class="number">
            <div class="header">
              <h4>数据概览</h4>
              <!-- <p>更多>></p> -->
            </div>
            <div class="main">
              <div v-for="(e,i) in numberList" :key="i" class="mainpic" :style="{background:'url(' + e.src +')'}">
                <p>{{e.text}}</p>
                <div style="display:flex;">
                  <p><vns :start="0" :end="e.num" :times="26" :speed="50"></vns></p>
                  <p>{{e.numre}}</p>
                </div>
              </div>
            </div>
          </div>
          
        </div>
        <div class="echarts">

          <div class="header">
            <h4>图片入库趋势</h4>
            <!-- <p @click="picMore">更多>></p> -->
          </div>

          <!-- :row-style="{height:51 + 'px'}" -->

          <div class="main">
            <div class="pictable">
              <line-echarts />

            </div>
          </div>
        </div>
      </div>

      <div class="disflex" style="width:100%;height:370px;">
        <div class="picneeds">

          <div class="header">
            <h4>用图需求</h4>
            <p @click="picMore">更多>></p>
          </div>

          <!-- :row-style="{height:51 + 'px'}" -->

          <div class="main">
            <div class="pictable" style="height:316px;">

              <el-table
                :data="picData"
                :row-style="{height:51 + 'px'}"
                style="width:100%;"
                >
                <el-table-column
                  prop="date"
                  label="日期"
                  :show-overflow-tooltip="true"
                  >
                </el-table-column>
                
                <el-table-column
                  prop="title"
                  :show-overflow-tooltip="true"
                  
                  label="需求标题">
                </el-table-column>
                <el-table-column
                  label="已收集图片"
                  :show-overflow-tooltip="true"
                  >
                  <template slot-scope="scope">
                    <div>
                      {{scope.row.zhang}}张/{{scope.row.ren}}人投稿
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  label="操作"
                  width="100">
                  <template slot-scope="scope">
                    <el-button type="text" size="small">修改</el-button>
                    <span> | </span>
                    <el-button type="text" size="small">关闭</el-button>

                  </template>
                </el-table-column>

              </el-table>

            </div>
          </div>

          <div class="tablebtn">
            <el-button> <i class="el-icon-plus"></i> 发布邀约</el-button>
          </div>
        </div>

        <div class="picneeds">

          <div class="header">
            <h4>征稿活动</h4>
            <p @click="picMore">更多>></p>
          </div>

          <!-- :row-style="{height:51 + 'px'}" -->

          <div class="main">
            <div class="pictable" style="height:316px;">

              <el-table
                :data="picData"
                :row-style="{height:51 + 'px'}"
                style="width:100%;"
                >
                <el-table-column
                  prop="date"
                  label="日期"
                  :show-overflow-tooltip="true"
                  >
                </el-table-column>
                
                <el-table-column
                  prop="title"
                  :show-overflow-tooltip="true"
                  
                  label="需求标题">
                </el-table-column>
                <el-table-column
                  label="已收集图片"
                  :show-overflow-tooltip="true"
                  >
                  <template slot-scope="scope">
                    <div>
                      {{scope.row.zhang}}张/{{scope.row.ren}}人投稿
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  label="操作"
                  width="100">
                  <template slot-scope="scope">
                    <el-button type="text" size="small">修改</el-button>
                    <span> | </span>
                    <el-button type="text" size="small">关闭</el-button>

                  </template>
                </el-table-column>

              </el-table>

            </div>
          </div>

          <div class="tablebtn">
            <el-button> <i class="el-icon-plus"></i> 创建活动</el-button>
          </div>
        </div>
      </div>

      
    </div>

    
  </div>
</template>

<script>
import vns from 'vue-number-scroll'
import { lineecharts } from '@/components/index'
export default {
  components:{
    'vns':vns,
    'line-echarts':lineecharts
  },
  data() {
      return {
        uploadsList:[
          {
            src:require('@/assets/house/onloadpic.png'),
            sheets:'451',
            title:'2020年度活动精选',
            time:'2020-03-27 15:10',
            isMode:false
          },
          {
            src:require('@/assets/house/onloadpic.png'),
            sheets:'41',
            title:'2019年报社优秀图片',
            time:'2020-03-27 15:10',
            isMode:true
          },
          {
            src:require('@/assets/house/onloadpic.png'),
            sheets:'253',
            title:'2019年报社优秀图片',
            time:'2020-03-27 15:10',
            isMode:false
          },
          {
            src:require('@/assets/house/onloadpic.png'),
            sheets:'23553',
            title:'2019年报社优秀图片',
            time:'2020-03-27 15:10',
            isMode:false
          },
          {
            src:require('@/assets/house/onloadpic.png'),
            sheets:'23553',
            title:'2019年报社优秀图片',
            time:'2020-03-27 15:10',
            isMode:false
          },
          {
            src:require('@/assets/house/onloadpic.png'),
            sheets:'41',
            title:'2019年报社优秀图片',
            time:'2020-03-27 15:10',
            isMode:true
          },
          {
            src:require('@/assets/house/onloadpic.png'),
            sheets:'41',
            title:'2019年报社优秀图片',
            time:'2020-03-27 15:10',
            isMode:true
          },
          {
            src:require('@/assets/house/onloadpic.png'),
            sheets:'41',
            title:'2019年报社优秀图片',
            time:'2020-03-27 15:10',
            isMode:true
          },
          {
            src:require('@/assets/house/onloadpic.png'),
            sheets:'41',
            title:'2019年报社优秀图片',
            time:'2020-03-27 15:10',
            isMode:true
          },
          {
            src:require('@/assets/house/onloadpic.png'),
            sheets:'41',
            title:'2019年报社优秀图片',
            time:'2020-03-27 15:10',
            isMode:true
          },
          {
            src:require('@/assets/house/onloadpic.png'),
            sheets:'41',
            title:'2019年报社优秀图片',
            time:'2020-03-27 15:10',
            isMode:true
          },
          {
            src:require('@/assets/house/onloadpic.png'),
            sheets:'41',
            title:'2019年报社优秀图片',
            time:'2020-03-27 15:10',
            isMode:true
          },
        ],
        picData:[
          {
            date: '2020-05-02',
            zhang: 20,
            ren: 3,
            title: '求9月14日全市运动会市长单人照1张'
          },
          {
            date: '2020-05-02',
            zhang: 0,
            ren: 0,
            title: '求2020年油菜花航拍图'
          },
          {
            date: '2020-05-02',
            zhang: 20,
            ren: 10,
            title: '求开幕式市长单人照1张'
          },
          {
            date: '2020-05-02',
            zhang: 20,
            ren: 10,
            title: '求古城建筑照片'
          },
          {
            date: '2020-05-02',
            zhang: 20,
            ren: 10,
            title: '求好看的螃蟹照片'
          }
        ],
        catalog:{
          url:"//192.168.1.199/cdp/abv3sxfd",
          username:'a00001',
          psw:'123456',
          hidpsw:'******'
        },
        catalogCopy:'',
        seepswFlag:false,  //是否隐藏密码
        numberList:[
          {
            src:require('@/assets/house/gpic1.png'),
            num:17642,
            text:'图片库'
          },
          {
            src:require('@/assets/house/gpic2.png'),
            num:152,
            // numre:'GB',
            text:'图集数量'
          },
          {
            src:require('@/assets/house/gpic3.png'),
            num:4545,
            text:'内部用户数'
          },
          {
            src:require('@/assets/house/gpic4.png'),
            num:999,
            text:'累计征稿活动'
          },
          {
            src:require('@/assets/house/gpic5.png'),
            num:17642,
            text:'图片数'
          },
          {
            src:require('@/assets/house/gpic6.png'),
            num:152,
            numre:'GB',
            text:'图片总大小'
          },
          {
            src:require('@/assets/house/gpic7.png'),
            num:4545,
            text:'图片被浏览次数'
          },
          {
            src:require('@/assets/house/gpic8.png'),
            num:999,
            text:'图片被下载次数'
          }
        ],
        navList:[
          {
            src:require('@/assets/house/nav1.png'),
            text:'快速上传'
          },
          {
            src:require('@/assets/house/nav3.png'),
            text:'我的下载'
          },
          {
            src:require('@/assets/house/nav2.png'),
            text:'我的图库'
          }
        ],
        displayResolution:''
      };
    },
    methods: {
      seePsw(){
        this.seepswFlag = !this.seepswFlag
      },
      // 复制成功时的回调函数
      onCopy (e) {
        console.log(e)
        this.$message.success("内容已复制到剪切板！")
      },
      // 复制失败时的回调函数
      onError (e) {
        this.$message.error("抱歉，复制失败！")
      },



      picMore(){
        this.$router.push('/config/picManage')
      }

    },
    created(){
      this.displayResolution = document.documentElement.clientWidth
      console.log(this.displayResolution)
    },
    mounted(){
      this.catalogCopy = '地址：'+ this.catalog.url +'；账号：' + this.catalog.username + ';密码：' + this.catalog.psw + '.'

      
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./house.scss";

.el-breadcrumb /deep/ .el-breadcrumb__inner{
  font-size: 14px;
  color:#5C5C5C;
}
/deep/ .el-table tbody tr:hover>td { 
  background-color:#FAFAFA;
}
/deep/ .el-table__header .has-gutter tr th div { 
  color:#999999;
  font-weight: bold;
}
/deep/ .el-table tbody tr td:hover>div { 
  color:#185ED3;
}
h4{
  font-size: 18px;
}
</style>
